(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("multi-range", [], factory);
	else if(typeof exports === 'object')
		exports["multi-range"] = factory();
	else
		root["multi-range"] = factory();
})(this, function() {
return 